<template>
  <v-app class="background-theme">
    <loading-layout v-if="loading"></loading-layout>
    <error-layout
      v-else-if="error"
      :error="error.message"
      :message="$t('error.tryAgain')"
      :code="error.status"
    ></error-layout>
    <updating-layout v-else-if="isUpdating"></updating-layout>
    <router-view v-else></router-view>
  </v-app>
</template>

<script>
import LoadingLayout from '@/views/layouts/LoadingLayout.vue';
import { mapActions, mapGetters } from 'vuex';
import UpdatingLayout from '@/views/layouts/UpdatingLayout.vue';
import ErrorLayout from '@/views/layouts/ErrorLayout.vue';

export default {
  metaInfo: {
    title: 'Анкета сотрудника',
  },
  components: {
    ErrorLayout,
    UpdatingLayout,
    LoadingLayout,
  },
  computed: {
    ...mapGetters('settings', ['isUpdating']),
  },
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    ...mapActions('settings', ['getSettings']),
    async fetchSettings() {
      this.loading = true;
      this.error = null;
      try {
        await this.getSettings();
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
